import $ from 'jquery';
import slick from 'slick-carousel';

// var $slickElementFirst = $('[data-slick]').first();
var $slickElement = $( '[data-slick]' );
// var $progressLabel = $('.counter');

if ( $slickElement.length ) {

  // Slick Defaults/init
  $slickElement.each( function ( num ) {
    $( this ).next( '.slider-buttons' ).addClass( "silder-menu-" + num );
    $( this ).next( '.slick-button-contain' ).find( '.slider-controls-left,  .slider-controls-right' ).addClass( "silder-menu-" + num );
    var $className = ".silder-menu-" + num
    $( this ).slick({
      arrows: true,
      dots: true,
      swipeToSlide: false,
      appendArrows: $className,
      appendDots: $className,
      prevArrow: '<button type="button" class="slick-prev">Prev</button>',
      rows: 0,
      adaptiveHeight: true
    });
});

//  Gallery modal
$( ".gallery-slideshow" ).slick({
  infinite: true,
  dots: false,
  arrows: false,
  adaptiveHeight: true,
  cssEase: 'linear',
  fade:true,
  
});

  // gallery modal to go to the current img clicked for the clider
  $( '.image-gallery-container > .gallery-image-wrapper' ).click( function( e ) {
    $( '.gallery-slideshow' ).slick( 'slickGoTo', $( this ).index());
  });

  // gallery nav slider left
  $( '.image-gallery-prev' ).click( function ( e ) {
    e.preventDefault();
    $( ".gallery-slideshow" ).slick( 'slickPrev' );
  });

  // gallery nav slider right
  $( '.image-gallery-next' ).click( function ( e ) {
    e.preventDefault();
    $( ".gallery-slideshow" ).slick( 'slickNext' );
  });

  // helpers
  function pad( n, width, z ) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array( width - n.length + 1 ).join( z ) + n;
  }
}

//Load more button
$( document ).on( 'click', '.js-button', () => {
  $( '.gallery-image-wrapper' ).removeClass( 'hidden' );
  $( '.js-button' ).hide();
});
